const transitionDuration = {
  faster: 100,
  default: 150,
  slower: 300,
} as const;

export default transitionDuration;
